import { render, staticRenderFns } from "./PPopup.vue?vue&type=template&id=d09c189e&"
import script from "./PPopup.vue?vue&type=script&lang=js&"
export * from "./PPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports